import RailsResource from "./rails-resource";


class AppointmentService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'attendance-lists',
      ajaxLoader: false
    });
  }

  update(appointment) {
    return this.patch(`${this.url}/${this.resource}/${appointment.batchScheduleId}/${appointment.date}/edit.json`, true, {
      appointment: { 'note': appointment.note }
    });
  }

  startedOnlineClass(appointmentId) {
    return this.post(`${this.url}/appointments/${appointmentId}/online/started`, true);
  }

  endOnlineClass(appointmentId) {
    return this.post(`${this.url}/appointments/${appointmentId}/online/end`, true);
  }

  postMeetingMessage(appointmentId, incomingMessage) {
    return this.post(`${this.url}/appointments/${appointmentId}/online/message`, true, {
      appointment: incomingMessage
    });
  }
}

export default new AppointmentService();